import { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageHeader, Card, Loading, Empty } from "../../components/admin/common";

export default function AuditLogs() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/audit-logs").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="Complete trail of important actions." />
      <Card>
        {rows === null ? <Loading /> : rows.length === 0 ? <Empty label="No activity yet" /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="border-b border-slate-100 text-left text-xs uppercase tracking-wider text-slate-500">
                {["Time", "User", "Action", "Record", "Details"].map((h) => <th key={h} className="px-5 py-3 font-semibold">{h}</th>)}
              </tr></thead>
              <tbody>
                {rows.map((l) => (
                  <tr key={l.id} className="border-b border-slate-50 hover:bg-slate-50/60" data-testid="audit-row">
                    <td className="px-5 py-3 text-xs text-slate-400 font-mono">{(l.timestamp || "").replace("T", " ").slice(0, 19)}</td>
                    <td className="px-5 py-3 text-slate-600">{l.user}</td>
                    <td className="px-5 py-3 font-medium text-slate-800">{l.action}</td>
                    <td className="px-5 py-3 text-xs text-slate-500 font-mono">{l.record_type} {l.record_id}</td>
                    <td className="px-5 py-3 text-slate-500">{l.details || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
